export const contentAmplification = {
  button: {
    label: 'Amplificar a {{channel}}',
    ariaLabel: 'Amplificar este contenido a {{channel}}',
  },
  drawer: {
    title: 'Amplificar a {{channel}}',
    close: 'Cerrar',
    reuseNote: 'Reusa el keyword research del blog',
    statusDraft: 'Borrador generado',
    statusGenerating: 'Generando…',
  },
  formats: {
    article: 'Artículo',
    posts: 'Posts',
  },
  loader: {
    title: 'Generando tu {{format}} de {{channel}}…',
    subtitle: 'Analizando el blog y reusando el keyword research',
  },
  article: {
    eyebrow: 'VISTA PREVIA · ARTÍCULO DE {{channel}}',
    bodyLabel: 'Cuerpo del artículo',
  },
  posts: {
    bodyLabel: 'Cuerpo del post',
    author: {
      name: 'Tu marca',
      tagline: 'Tu empresa',
      meta: 'Ahora · 🌐',
    },
    engagement: {
      likes: 'Me gusta',
      comments: 'Comentarios',
      reposts: 'Republicaciones',
    },
  },
  footer: {
    copy: 'Copiar',
    copied: 'Copiado',
    export: 'Exportar',
    regenerate: 'Regenerar',
    delete: 'Eliminar',
    schedule: 'Programar vía IBT',
    soon: 'Pronto',
  },
  deleteDialog: {
    title: '¿Eliminar el borrador de {{format}}?',
    description: 'Se elimina el contenido generado. Podés volver a generarlo cuando quieras.',
    cancel: 'Cancelar',
    confirm: 'Eliminar',
  },
  empty: {
    title: 'Sin borrador',
    description: 'Todavía no hay un {{format}} generado para este contenido.',
    generate: 'Generar',
  },
  toast: {
    copied: 'Contenido copiado al portapapeles',
    copyError: 'No se pudo copiar al portapapeles',
    exported: 'Contenido exportado',
    regenerated: 'Contenido regenerado',
    regenerateError: 'No se pudo regenerar el contenido',
    deleted: 'Borrador eliminado',
    deleteError: 'No se pudo eliminar el borrador',
  },
  error: {
    title: 'No se pudo generar el contenido',
    description: 'Intentá de nuevo en unos segundos.',
    retry: 'Reintentar',
  },
} as const
